import { ref, type Ref } from 'vue';
import { AuthUser } from '/@/modules/auth/models/AuthUser';
import Echo from 'laravel-echo';

export const user: Ref<AuthUser | null> = ref(null);
export const echo: Ref<Echo | undefined> = ref(undefined);
